<template>
  <div class="wt2-story-actions wt2-thumbnail-panel">
    <wt-close @click.native="close" />

    <span @click="edit" :class="{ disabled: isLocked }">
      <i class="wticon wticon-pencil3" />
      {{ 'storyPreview.edit' | culture }}
    </span>

    <span :class="{ disabled: !isUserCanCreateStories }" @click="duplicateItem">
      <i class="wticon wticon-duplicate" />
      {{ 'storyPreview.copy' | culture }}
    </span>

    <span
      :class="{ disabled: !isUserCanCreateStories || isLocked }"
      @click="deleteItem"
    >
      <i class="wticon wticon-trash2" />
      {{ 'storyPreview.remove' | culture }}
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'story-preview-card-actions',

  props: {
    isLocked: { type: Boolean, required: true },
  },

  data() {
    return {
      visible: true,
    };
  },

  computed: {
    ...mapGetters(['isUserCanCreateStories']),
  },

  methods: {
    close() {
      this.$emit('action', { type: 'close' });
    },

    edit() {
      this.$emit('action', { type: 'edit' });
    },

    deleteItem() {
      this.$emit('action', { type: 'delete' });
    },

    duplicateItem() {
      this.$emit('action', { type: 'duplicate' });
    },
  },
};
</script>

<style scoped></style>
